import React from "react";
import ServiceMatching from "./ServiceMatching";

const ServiceMatchingHome = () => <ServiceMatching />;

export default ServiceMatchingHome;
